import Loader from 'components/Loader';
import Error404 from 'pages/maintenance/error/404';
import { ReactNode } from 'react';
import { useSelector } from 'store';
// import { RoutesEnum } from 'utils/routesEnum';

interface PermissionGuardProps {
  children: ReactNode;
  requiredPermissions: string[];
}

const routePermissions = {
  home: [],
  chat: ['manage_chat'],
  'relatorio-atendimentos': ['report_attendance'],
  'dashboard-atendimentos': ['dashboard_attendance'],
  contatos: ['manage_contact'],
  grupos: ['manage_contact_group'],
  canais: ['manage_channel'],
  departamento: ['manage_department'],
  campanhas: ['manage_campaign'],
  'dashboard-campanhas': ['dashboard_campaign'],
  comunidades: ['manage_community'],
  usuario: ['manage_user'],
  tags: ['manage_tag'],
  templates: ['manage_template'],
  administracao: ['manage_user', 'manage_profile'],
  // parâmetros de atendimento: só quem administra perfis (o Admin). Reaproveita a tag
  // manage_profile em vez de criar uma nova, que exigiria seed manual em cada cliente
  'administracao-atendimento': ['manage_profile'],
  // gate da rota: mostra se tiver QUALQUER uma das três (RN05) — dentro da página,
  // RegistrationsPage filtra as abas por permissão individual
  cadastros: ['manage_department', 'manage_tag', 'manage_profile'],
  // mesmo motivo de administracao-atendimento: reaproveita manage_profile, sem tag nova
  'administracao-notificacoes': ['manage_profile'],
  // idem — Auditoria é tão sensível quanto as outras telas de Administração, mesma tag
  'administracao-auditoria': ['manage_profile']
};

const PermissionGuard = ({ children, requiredPermissions }: PermissionGuardProps) => {
  const { user } = useSelector((state) => state.auth);

  if (requiredPermissions.length === 0) {
    if (!user) {
      // window.location.href = RoutesEnum.LOGIN;
      return <Loader />;
    }
    return <>{children}</>;
  }

  if (!user) {
    return <Loader />;
  }

  if (user && !user.permissions?.some((perm) => requiredPermissions.includes(perm))) {
    return <Error404 />;
  }

  return <>{children}</>;
};

export { PermissionGuard, routePermissions };
